import API from "@irati/utils/services/API"

import getShortKey from "@irati/utils/getShortKey"
import endpoints from "../endpoints"

import {postImageErrorHandler, getImageErrorHandler} from "./errors/imageErrorHandlers"

const service = {}

service.create = (base64) => {
  return API.post(endpoints.images(), {image: base64})
    .then((response) => {
      return getImage(getShortKey(response.data.links.self, "v1/images/"))
    })
    .catch(postImageErrorHandler)
}

service.get = (id) => {
  return API.get(endpoints.image(id))
    .then((response) => {
      return response.data.imageUrl
    })
    .catch(getImageErrorHandler)
}

service.delete = () => {
  // We need to support this in future. Adding for transparent update
  return Promise.resolve()
}

export const uploadImage = service.create
export const getImage = service.get
export const deleteImage = service.delete

export default service
